import './About.css'

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">What ECHO Does</span>
          <h2>Your Voice Deserves to Be Heard</h2>
          <p className="section-subtitle">
            Born from a vision of comfort and connection, ECHO helps families find calm
            in life's most difficult moments — with clarity, warmth, and love.
          </p>
        </div>
        <div className="about-content">
          <div className="about-text">
            <p className="about-description">
              ECHO stands at the intersection of legacy planning and compassionate care.
              We believe preparation is an act of love — not paperwork, but a gift of
              peace for the people who matter most.
            </p>
            <div className="about-marketing">
              <div className="media-frame media-frame--banner about-media">
                <img src="/marketing1.png" alt="ECHO — Give your family peace of mind" />
              </div>
              <div className="media-frame media-frame--banner about-media">
                <img src="/marketing2.png" alt="ECHO family connection and legacy planning" />
              </div>
              <div className="media-frame media-frame--portrait about-media about-media--portrait">
                <img src="/bookmark-design.png" alt="ECHO bookmark — Your voice lives" />
              </div>
            </div>
            <p className="about-description">
              From medical history and end-of-life wishes to love letters and treasured
              memories — everything your family needs lives in one sacred, organized place.
              No searching. No confusion. Just the comfort of knowing.
            </p>
            <blockquote className="about-quote">
              "This is your voice when you can't speak. Your wisdom passed down."
            </blockquote>
          </div>
        </div>
      </div>
      <div className="about-voicelives">
        <div className="media-frame media-frame--landscape voicelives-frame">
          <img src="/yourvoicelives.png" alt="Your Voice Lives" className="voicelives-img" />
        </div>
      </div>
    </section>
  )
}

export default About
